import { render, staticRenderFns } from "./DailyComparisonCardDbmRisk.vue?vue&type=template&id=46c8b555"
import script from "./DailyComparisonCardDbmRisk.vue?vue&type=script&lang=js"
export * from "./DailyComparisonCardDbmRisk.vue?vue&type=script&lang=js"
import style0 from "./DailyComparisonCardDbmRisk.vue?vue&type=style&index=0&id=46c8b555&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports